import $ from "cash-dom";
import { mapValue } from "Utilities";
import getZoomValues from "./function_get-zoom-values";

export default function zoom($wrapper, _focus, _scale) {
    const zoom = getZoomValues(_focus, _scale);
    const [xStr, yStr] = _focus.split(",");
    const xPercent = parseFloat(xStr) / 100;
    const yPercent = parseFloat(yStr) / 100;

    $wrapper.css({
        transformOrigin: "50% 50%",
        transform: `translate3d(${zoom.x}%, ${zoom.y}%, 0) scale(${zoom.scale})`,
    });

    if (log) {
        const $dot = $(`<div class="dot"></div>`);

        $dot.css({
            position: "absolute",
            width: "6px",
            height: "6px",
            borderRadius: "50%",
            backgroundColor: "red",
            left: `${xPercent * 100}%`,
            top: `${yPercent * 100}%`,
            transform: "translate3d(-50%, -50%, 0)",
            pointerEvents: "none",
            zIndex: 9999,
        });

        $wrapper.css("position", "relative").append($dot);
    }
}
